<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8027_77438)">
      <path
        d="M4.08317 4.08366H4.089M12.0107 7.82283L7.82817 12.0053C7.71982 12.1138 7.59115 12.1999 7.44952 12.2586C7.30789 12.3173 7.15607 12.3475 7.00275 12.3475C6.84944 12.3475 6.69762 12.3173 6.55599 12.2586C6.41436 12.1999 6.28569 12.1138 6.17734 12.0053L1.1665 7.00033V1.16699H6.99984L12.0107 6.17783C12.228 6.39642 12.3499 6.69211 12.3499 7.00033C12.3499 7.30854 12.228 7.60424 12.0107 7.82283Z"
        stroke="#F7F8FD"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8027_77438">
        <rect
          width="14"
          height="14"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>